import { useEffect, useRef, useState } from "react";
import "../styles/autoScroll.css";


export default function AutoScrollSection({ children }) {
    const sectionRef = useRef(null);
    const trackRef = useRef(null);

    const [visible, setVisible] = useState(false);
    const [hover, setHover] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setVisible(entry.isIntersecting),
            { threshold: 0.3 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!trackRef.current) return;

        trackRef.current.style.animationPlayState =
            visible && !hover ? "running" : "paused";
    }, [visible, hover]);

    return (
        <section
            ref={sectionRef}
            className="scroll-container"
            aria-hidden="true"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onTouchStart={() => setHover(true)}
            onTouchEnd={() => setHover(false)}
        >
            <div ref={trackRef} className="scroll-track">
                {children}
                {children} {/* required for infinite loop */}
            </div>
        </section>
    );
}

